import React, { useRef } from 'react';
import Flex from 'components/Flex';
import styled from 'styled-components';
import Footer from './Footer';
import useWebsiteMenu from './useWebsiteMenu';
import { useStickyOffset } from 'hooks/useStickyOffset';

const MENU_WIDTH = 304;
const FOOTER_HEIGHT = 190;
const PADDING_TOP = 80;

const WebsiteLeftMenuDesktop = ({ sticky = true }) => {
  const { renderItems } = useWebsiteMenu();
  const itemsRef = useRef<HTMLDivElement>(null);
  const { topOffset } = useStickyOffset(itemsRef, { sticky, marginTop: PADDING_TOP });

  return (
    <Menu direction="column" justifyContent="space-between">
      <ItemsWrapper sticky={sticky} topOffset={topOffset}>
        <ItemsContainer ref={itemsRef}>{renderItems()}</ItemsContainer>
        <FooterSpacer />
      </ItemsWrapper>
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </Menu>
  );
};

export default WebsiteLeftMenuDesktop;

const Menu = styled(Flex)`
  width: ${MENU_WIDTH}px;
  padding-top: ${PADDING_TOP}px;
  background-color: ${(props) => props.theme.colors.secondary};
  min-height: 100vh;
  box-sizing: border-box;
  flex-direction: column;
  position: relative;
  overflow: visible;
  ${(props) => props.theme.media.md`
    display: none;
  `}
`;

const ItemsWrapper = styled.div<{ sticky: boolean; topOffset: number }>`
  position: ${(p) => (p.sticky ? 'sticky' : 'relative')};
  top: ${(p) => (p.sticky ? `${p.topOffset}px` : '0')};
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${MENU_WIDTH}px;
  z-index: 0;
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const FooterSpacer = styled.div`
  height: ${FOOTER_HEIGHT}px;
  flex-shrink: 0;
`;

const FooterWrapper = styled.div`
  position: relative;
  z-index: 1;
`;
